import React from 'react';
import { IconFacebookF, IconLinkedinIn, IconTwitter, IconYoutube, IconArrowRight } from './icons';
import { SITE } from '../../config/site';

/**
 * 📣 SUIVEZ-NOUS : pages officielles de la plateforme (src/config/site.js → social).
 * Seuls les réseaux renseignés apparaissent ; rien n'est affiché si aucun ne l'est.
 */
export const SOCIAL_NETWORKS = [
  { key: 'facebook', name: 'Facebook', icon: IconFacebookF, color: 'bg-[#1877F2]', hover: 'hover:bg-[#166FE5]', text: 'Nos actualités, les nouveaux projets et les événements, au jour le jour.', action: 'Suivre la page' },
  { key: 'linkedin', name: 'LinkedIn', icon: IconLinkedinIn, color: 'bg-[#0A66C2]', hover: 'hover:bg-[#004182]', text: 'Notre page entreprise : la vie de la plateforme et nos partenariats.', action: 'Suivre l\'entreprise' },
  { key: 'twitter', name: 'X (Twitter)', icon: IconTwitter, color: 'bg-black', hover: 'hover:bg-gray-800', text: 'Nos annonces en bref.', action: 'Suivre le compte' },
  { key: 'youtube', name: 'YouTube', icon: IconYoutube, color: 'bg-[#FF0000]', hover: 'hover:bg-[#CC0000]', text: 'Nos vidéos de présentation et de projets.', action: 'S\'abonner' }
].filter(network => SITE.social[network.key]);

/** Petites icônes rondes (barre du haut, pied de page) */
export const SocialIcons = ({ className = '', itemClassName = 'h-7 w-7 bg-white/10 text-white hover:bg-white/25' }) => (
  SOCIAL_NETWORKS.length > 0 && (
    <ul className={`flex items-center gap-2 ${className}`} aria-label="Nos réseaux sociaux">
      {SOCIAL_NETWORKS.map(network => (
        <li key={network.key}>
          <a href={SITE.social[network.key]} target="_blank" rel="noopener noreferrer" aria-label={`${SITE.name} sur ${network.name}`}
            className={`inline-flex items-center justify-center rounded-full transition-colors ${itemClassName}`}>
            <network.icon className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  )
);

/** Bandeau « Suivez-nous » avec une carte par réseau */
const SocialFollow = ({ title = 'Suivez-nous sur les réseaux sociaux', intro = 'Rejoignez notre communauté et ne manquez aucune nouvelle de la plateforme.', tone = 'white' }) => {
  if (SOCIAL_NETWORKS.length === 0) return null;
  return (
    <section aria-labelledby="suivez-nous-titre" className={`${tone === 'muted' ? 'bg-gray-50' : 'bg-white'} py-14 sm:py-16`}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 id="suivez-nous-titre" className="text-2xl font-bold text-gray-900 sm:text-3xl">{title}</h2>
          <p className="mx-auto mt-3 max-w-2xl text-gray-600">{intro}</p>
        </div>
        <ul className={`mx-auto mt-10 grid gap-5 ${
          SOCIAL_NETWORKS.length === 1 ? 'max-w-md'
            : SOCIAL_NETWORKS.length === 2 ? 'max-w-4xl sm:grid-cols-2'
              : SOCIAL_NETWORKS.length === 3 ? 'lg:grid-cols-3' : 'sm:grid-cols-2'
        }`}>
          {SOCIAL_NETWORKS.map(network => (
            <li key={network.key}>
              <a href={SITE.social[network.key]} target="_blank" rel="noopener noreferrer"
                className={`group flex h-full items-center gap-5 rounded-3xl p-6 text-white shadow-lg transition-all hover:-translate-y-1 hover:shadow-xl ${network.color} ${network.hover}`}>
                <span className="inline-flex h-16 w-16 flex-none items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/30">
                  <network.icon className="h-8 w-8" aria-hidden="true" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-xl font-bold">{network.name}</span>
                  <span className="mt-1 block text-sm leading-relaxed text-white/85">{network.text}</span>
                  <span className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 text-sm font-semibold text-gray-900">
                    {network.action} <IconArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                  </span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SocialFollow;
